<h6>{{ connection?.Namespace }} Topics</h6>
<kendo-grid
  #grid
  [data]="view | async"
  [style.height.%]="100"
  [pageSize]="gridState.take"
  [skip]="gridState.skip"
  [sort]="gridState.sort"
  [pageable]="false"
  [sortable]="false"
  [filterable]="false"
  (dataStateChange)="onStateChange($event)"
  [navigable]="true"
  [loading]="loading"
  [resizable]="true">

    <kendo-grid-column
        field="Id"
        title="ID"
        width="100"
        [editable]="false"
        [hidden]="true">
    </kendo-grid-column>

    <kendo-grid-column
        field="ConnectionId"
        title="Connection Id"
        width="100"
        [editable]="false"
        [hidden]="true">
    </kendo-grid-column>

    <kendo-grid-column
        field="Name"
        title="Name"
        width="300">
    </kendo-grid-column>

    <kendo-grid-column
        field="IsActive"
        title="Active"
        width="100">
    </kendo-grid-column>

    <kendo-grid-column
        field="MaxSize"
        title="Max Size (Mb)"
        width="150">
    </kendo-grid-column>

    <kendo-grid-column
        field="IsPartitioned"
        title="Partitioned"
        width="100">
    </kendo-grid-column>

    <div *kendoGridDetailTemplate="let dataItem">
        <app-subscriptions
          [connection]="connection"
          [topic]="dataItem">
        </app-subscriptions>
    </div>
</kendo-grid>


